export const buildScopeRequestKey = ({ projectId, scopeKey, documentCode } = {}) => {
  if (!projectId || !scopeKey || !documentCode) return '';
  return `${projectId}:${scopeKey}:${documentCode}`;
};

export const shouldLoadScopeRequest = (lastRequestKey, nextRequestKey) => (
  Boolean(nextRequestKey) && lastRequestKey !== nextRequestKey
);
